import { svcApi, extract, logger } from '.';
import { Common, Crop } from '@crops';
import ApiMapper from 'constant/ApiMapper';

type Param = {
  url: string;
};


type Tli = {
  // 리 코드
  li_nm: string;
  li_cd: string;
};

const mapper = ApiMapper.COMMON.BOOTSTRAP;

const CommonApi = {
  // 공통코드 검색 API
  CommonCode: async (cmmnCdClsId: Common.Tcode): Promise<Common.Legends[]> => {
    if (!cmmnCdClsId) throw new Error('cmmnCdClsId not defined');
    const result = await svcApi.get(`${mapper.CODE_LIST}/${cmmnCdClsId}`);

    return extract(result);
  },
  // 시 리스트
  ListCtpv: async (reqParam: Param): Promise<Common.Tctpv[]> => {
      const result = await svcApi.get(reqParam.url);
      return extract(result);
    },
  // 시군구 리스트
  ListSgg: async ({ url, regionCode }: { url: string; regionCode: string }): Promise<Common.Temd[]> => {
    const result = await svcApi.get(url, {
      params: { regionCode },
    });

    return extract(result);
  },
  ListEmd: async ({ url, regionCode }: { url: string; regionCode: string }): Promise<Common.Temd[]> => {
    const result = await svcApi.get(url, {
      params: { regionCode },
    });

    return extract(result);
  },

  ListLi: async ({ url, regionCode }: { url: string; regionCode: string }): Promise<Tli[]> => {
    const result = await svcApi.get(url, {
      params: { regionCode },
    });

    return extract(result);
  },
  CoordToAddr: async ({
    lat,
    lng,
  }: {
    lat: number;
    lng: number;
  }): Promise<{
    emd_nm: string;
    emd_cd: string;
    sgg_cd: string;
    sgg_nm: string;
  }> => {
    const result = await svcApi.get(ApiMapper.COMMON.FIND_EMD, {
      params: {
        lat,
        lng,
      },
    });

    return extract(result);
  },
  ImageList: async ({ url, params }: { url: string; params: object }): Promise<Common.ImagaList[]> => {
    const result = await svcApi.get(ApiMapper.COMMON.IMAGE_LIST, {
      params: params,
    });

    return extract(result);
  },
};

export default CommonApi;
